import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faFileText } from '@/fontawesome';
import { formatDate } from '@/utils/helpers';
import UserSessionsList from '@/components/admin/users/UserSessionsList';
import type { User, Scratchpad } from '@/models';

interface UserDetailPageTabChatsProps {
  user: User;
  scratchpad: Scratchpad | null;
}

export default function UserDetailPageTabChats({ user, scratchpad }: UserDetailPageTabChatsProps) {
  return (
    <div className="space-y-8">
      {/* Chat Sessions */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
          <FontAwesomeIcon icon={faComments} className="w-6 h-6 mr-3" />
          Chat-Sitzungen
        </h2>
        <UserSessionsList userId={user.id} userName={`${user.firstName} ${user.lastName}`} />
      </div>

      {/* Scratchpad */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-6">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
          <FontAwesomeIcon icon={faFileText} className="w-6 h-6 mr-3" />
          Notizblock
        </h2>
        {scratchpad !== null && scratchpad.content.trim() ? (
          <div>
            <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-6 border border-gray-200 dark:border-gray-700">
              <pre className="text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap overflow-x-auto">
                {scratchpad.content}
              </pre>
            </div>
            <div className="mt-4 text-sm text-gray-500 dark:text-gray-400">
              Zuletzt aktualisiert: {formatDate(scratchpad.updated ?? scratchpad.created)}
            </div>
          </div>
        ) : (
          <div className="text-center py-8">
            <FontAwesomeIcon icon={faFileText} className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400 italic">
              Kein Notizblock-Inhalt vorhanden
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
